module.exports = __webpack_public_path__ + "img/MCM.da6b5704.png";